export default function (action, params = {}) {
	const attributes = {
		class: this.html.classes('action', 'action--submit'),
		type: 'submit'
	};
	return this.render('button', action, attributes);
}
